import React, { useEffect } from "react";
import PageHeaderSmall from "../../components/PageHeaderSmall";
import ContactForm from "../../components/ContactForm";
import { useNavContext } from "../../context-api/nav-context";

const Contact = () => {
  const { closeNavbarMenu } = useNavContext();
  const title = "Contact Us";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <PageHeaderSmall title={title} onMouseOver={closeNavbarMenu} />
      <section
        className="section-wrapper contact-global"
        onMouseOver={closeNavbarMenu}
      >
        <div className="contact-page_form-container">
          <ContactForm />
        </div>
        <div className="contact-page_address">
          <h3 className="contact_text_sub">
            We are experienced plumbers, central heating and gas engineers based
            in Leeds.
          </h3>
          <h4 className="contact-page_sub">Address</h4>
          <p className="contact_text">
            Francis house, George Mann way Leeds, LS10 1DJ
          </p>
          <h4 className="contact-page_sub">Phone</h4>
          <p className="contact_text">0113 467 0278 </p>
          <h4 className="contact-page_sub">Email</h4>
          <p className="contact_text">response@aquaheatplumbingltd.com</p>
        </div>
      </section>
      <div className="reviews-image" onMouseOver={closeNavbarMenu}>
        <img
          src="https://res.cloudinary.com/duwmjod0j/image/upload/q_100/v1642187765/AquaHeat/Home%20Reviews/reviews_oyltwu.webp"
          alt="reviews"
        />
      </div>
    </>
  );
};

export default Contact;
